interface CardItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
  rating: string;
  eps: string;
}

const cards: CardItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20elegant%20costumes%2C%20warm%20golden%20lighting%2C%20ornate%20architecture%2C%20cinematic%20composition%2C%20soft%20ambient%20glow%2C%20stylized%20illustration%20style%2C%20rich%20warm%20tones%2C%20clean%20background&width=600&height=400&seq=card-01&orientation=landscape",
    title: '星落长河',
    tag: '古装·权谋',
    desc: '年度古装巨制，宫廷权谋与儿女情长的完美交织，48集全',
    rating: '9.4',
    eps: '48集全',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Mystery%20crime%20drama%20scene%20with%20detective%20in%20dark%20city%20alley%2C%20neon%20lights%2C%20rainy%20night%2C%20suspenseful%20atmosphere%2C%20warm%20orange%20and%20teal%20color%20contrast%2C%20stylized%20illustration%2C%20cinematic%20lighting&width=600&height=400&seq=card-02&orientation=landscape",
    title: '暗夜追踪',
    tag: '悬疑·刑侦',
    desc: '连环案件环环相扣，每一集都有意想不到的反转',
    rating: '9.1',
    eps: '更新至32集',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20couple%20under%20cherry%20blossoms%2C%20soft%20pastel%20lighting%2C%20warm%20spring%20atmosphere%2C%20emotional%20mood%2C%20stylized%20illustration%2C%20gentle%20color%20palette%2C%20dreamy%20bokeh%20effect&width=600&height=400&seq=card-03&orientation=landscape",
    title: '月之恋人',
    tag: '韩剧·浪漫',
    desc: '奇幻穿越遇上命中注定的爱情，16集甜到心坎',
    rating: '8.9',
    eps: '16集全',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20digital%20world%2C%20holographic%20displays%2C%20cyberpunk%20city%2C%20dark%20and%20mysterious%20atmosphere%2C%20warm%20orange%20accents%20on%20dark%20background%2C%20stylized%20illustration%2C%20clean%20composition&width=600&height=400&seq=card-04&orientation=landscape",
    title: '边缘世界',
    tag: '科幻·烧脑',
    desc: '美剧科幻神作第三季，虚拟与现实边界彻底模糊',
    rating: '9.3',
    eps: '更新至8集',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Modern%20urban%20office%20drama%20scene%20with%20young%20professionals%2C%20glass%20buildings%2C%20warm%20evening%20light%2C%20city%20skyline%20through%20windows%2C%20stylized%20illustration%2C%20warm%20amber%20tones%2C%20clean%20modern%20aesthetic&width=600&height=400&seq=card-05&orientation=landscape",
    title: '都市夜话',
    tag: '职场·情感',
    desc: '都市青年职场奋斗与感情纠葛的真实写照',
    rating: '8.7',
    eps: '第二季即将上线',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Martial%20arts%20fantasy%20scene%20with%20warriors%20in%20dramatic%20landscape%2C%20epic%20mountain%20scenery%2C%20golden%20sunset%20lighting%2C%20heroic%20atmosphere%2C%20stylized%20illustration%2C%20warm%20dramatic%20tones%2C%20cinematic%20wide%20shot&width=600&height=400&seq=card-06&orientation=landscape",
    title: '风起云涌',
    tag: '武侠·热血',
    desc: '评分9.2口碑爆款，江湖儿女快意恩仇的故事',
    rating: '9.2',
    eps: '全剧终',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Anime%20style%20scene%20with%20vibrant%20characters%2C%20dynamic%20action%20pose%2C%20colorful%20energy%20effects%2C%20warm%20lighting%2C%20stylized%20Japanese%20animation%20aesthetic%2C%20bold%20composition%2C%20rich%20saturated%20colors&width=600&height=400&seq=card-07&orientation=landscape",
    title: '星辰变',
    tag: '国漫·玄幻',
    desc: '国产动画巅峰之作，视觉特效炸裂每一帧',
    rating: '9.0',
    eps: '更新至56集',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">编辑精选，本周必看高分好剧</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-1 rounded bg-background-50/90 text-foreground-700 whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 text-xs font-bold px-2 py-0.5 rounded bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{item.desc}</p>
                <p className="text-[11px] text-foreground-400">{item.eps}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-1 rounded bg-background-50/90 text-foreground-700 whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 text-xs font-bold px-2 py-0.5 rounded bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                <p className="text-[11px] text-foreground-400 mt-2">{item.eps}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}